import { render, staticRenderFns } from "./JobPreviewNew.vue?vue&type=template&id=56d471cc&scoped=true&"
import script from "./JobPreviewNew.vue?vue&type=script&lang=js&"
export * from "./JobPreviewNew.vue?vue&type=script&lang=js&"
import style0 from "./JobPreviewNew.vue?vue&type=style&index=0&id=56d471cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d471cc",
  null
  
)

export default component.exports